import { render, staticRenderFns } from "./WidgetMasonry.vue?vue&type=template&id=40c24776&"
import script from "./WidgetMasonry.vue?vue&type=script&lang=js&"
export * from "./WidgetMasonry.vue?vue&type=script&lang=js&"
import style0 from "./WidgetMasonry.vue?vue&type=style&index=0&id=40c24776&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports